import { render, staticRenderFns } from "./basic-information.vue?vue&type=template&id=6ee80f3c&scoped=true"
import script from "./basic-information.vue?vue&type=script&lang=js"
export * from "./basic-information.vue?vue&type=script&lang=js"
import style0 from "./basic-information.vue?vue&type=style&index=0&id=6ee80f3c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee80f3c",
  null
  
)

export default component.exports